import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { AlertTriangle, Clock, FileText, X } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function DocumentBanner() {
  const { user } = useAuth();
  const [status, setStatus] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (!user || user === false || user.role === 'admin') return;
    const token = localStorage.getItem('lifelink_token');
    if (!token) return;

    const fetchStatus = async () => {
      try {
        const { data } = await axios.get(`${API}/auth/document-status`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setStatus(data);
      } catch { /* ignore */ }
    };
    fetchStatus();
  }, [user]);

  if (!status || status.documento_verificato || dismissed) return null;
  if (!status.scaduto && status.giorni_rimanenti > 3) return null;

  const isExpired = status.scaduto;

  return (
    <div className={`border-b ${isExpired ? 'border-[#FF3B30]/30 bg-[#FF3B30]/8' : 'border-[#FF9F0A]/30 bg-[#FF9F0A]/8'}`} data-testid="document-banner">
      <div className="max-w-7xl mx-auto px-4 py-3 flex items-center gap-3">
        {isExpired ? (
          <AlertTriangle size={18} className="text-[#FF3B30] flex-shrink-0" />
        ) : (
          <Clock size={18} className="text-[#FF9F0A] flex-shrink-0" />
        )}
        <div className="flex-1 min-w-0">
          <p className="text-xs font-bold" style={{ color: isExpired ? '#FF3B30' : '#FF9F0A' }}>
            {isExpired
              ? 'Documento scaduto! Carica il tuo documento per continuare.'
              : `Hai ${status.giorni_rimanenti} giorni per caricare il documento d'identità.`
            }
          </p>
        </div>
        <Link
          to="/verifica-documento"
          className={`flex items-center gap-1 px-4 py-1.5 text-[10px] font-bold uppercase tracking-widest text-white flex-shrink-0 ${
            isExpired ? 'bg-[#FF3B30] hover:bg-[#FF1A1A]' : 'bg-[#FF9F0A] hover:bg-[#E68F00]'
          } transition-all`}
          data-testid="upload-document-link"
        >
          <FileText size={12} />
          Carica Documento
        </Link>
        {!isExpired && (
          <button onClick={() => setDismissed(true)} className="text-[#4A6B8A] hover:text-[#FF3B30] p-1" data-testid="dismiss-doc-banner">
            <X size={14} />
          </button>
        )}
      </div>
    </div>
  );
}
